/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon20Light = forwardRef('GovKoRosreestrIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7.5a6.5 6.5 0 1 1 6.98 6.483A5.5 5.5 0 0 1 5.5 19h-1a.5.5 0 0 1-.5-.5v-11ZM5.022 7A5.502 5.502 0 0 1 10 2.022V7H5.022ZM5 13V8h5v5H5Zm0 1v4h.5a4.5 4.5 0 0 0 4.473-4H5Zm10.978-6A5.502 5.502 0 0 1 11 12.978V8h4.978ZM11 2.022A5.502 5.502 0 0 1 15.978 7H11V2.022Z" })));
});
